//!!!!! TODO: Do not mutate state directly fix it asap!!!!!!
import React from 'react'
import Reflux from 'reflux'
import Store from '../../store/store'
import BaseComponent from '../base'
import api from "../../source/api";
import i18 from "../../i18";
import Modal from "react-modal";
import Loading from "../common/loading";
import Field from "../common/Field";

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: '800px'
    }
}
const modalBodyStyles = {
    maxHeight: 'calc(100vh - 200px)',
    overflow: 'auto'
}

class NavCashregisterList extends BaseComponent {

    constructor(props) {
        super(props)
        this.state = {
            navCashregisters: props.navCashregisters,
            company: props.company,
            reports: null,
            modalIsOpen: false,
            fields: {
                apNumber: {value: '', error: '', role: {required: true}},
            },
        }

        console.log(props);
        this.store = Store
    }

    closeModal = () => {
        this.setState({modalIsOpen: false})
    }

    showReport = (apNumber) => {
        this.setState({
            reports: null,
            modalIsOpen: true
        })
        api
            .get({url: 'cashregister/nav-cashregister/report/' + apNumber + '?company_id=' + this.state.company.id}, true)
            .then((response) => {
                this.setState({
                    reports: response.data.reports
                })
            })
    }

    deleteReport = (apNumber) => {
        if (!window.confirm('Biztos törölni szeretné?')) {
            return;
        }

        document.body.classList.toggle('loading-body', true)
        api
            .delete({url: 'cashregister/nav-cashregister/delete/' + apNumber + '?company_id=' + this.state.company.id}, true)
            .then((response) => {
                this.setState({
                    navCashregisters: response.data.navCashregisters
                })
                document.body.classList.toggle('loading-body', false)
            })
    }

    setValue = (name, value, error) => {
        let fields = this.state.fields;
        fields[name].value = value;
        fields[name].error = error;
        this.setState({fields: fields})
    };

    addItem = () => {
        if (this.state.fields.apNumber.value === '') {
            this.props.notifyError('AP szám nem lehet üres');
            return;
        }

        document.body.classList.toggle('loading-body', true)
        api
            .put({url: 'cashregister/nav-cashregister/add/' + this.state.fields.apNumber.value + '?company_id=' + this.state.company.id}, true)
            .then((response) => {
                this.setState({
                    navCashregisters: response.data.navCashregisters
                })

                let fields = this.state.fields;
                fields.apNumber.value = '';
                fields.apNumber.error = '';
                this.setState({fields: fields})

                document.body.classList.toggle('loading-body', false)
            })
            .catch((err) => {
                document.body.classList.remove('loading-body')
                this.props.notifyError(err.response.data.msg, 'error')
            })
    }

    render() {
        return (
            <section id='nav-cashregister-list'>
                <div className='header'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12'>
                                <h1 className='mt-5'>
                                    <a onClick={() => this.props.switchShowingNavCashregisterList()} className='choose-btn'>{i18.BUTTONS._back}</a>
                                    {i18.CASHREGISTER._navCashregisterTitle}
                                </h1>
                                <h4 className='text-left my-5'>Kiválasztott cég : {this.state.company ? this.state.company.name : ''}</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='body'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12'>
                                <table className='table table-striped  table-aibook-no-border'>
                                    <thead>
                                    <tr>
                                        <th>AP szám</th>
                                        <th>Elérhető állomány kezdete</th>
                                        <th>Elérhető állomány vége</th>
                                        <th>Utolsó betöltés</th>
                                        <th style={{width: '220px'}}></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.navCashregisters.map((cashregister) => {
                                        return <tr key={cashregister.apNumber}>
                                            <td>{cashregister.apNumber}</td>
                                            <td>{cashregister.availableFrom}</td>
                                            <td>{cashregister.availableTo}</td>
                                            <td>{cashregister.lastFileSynced}</td>
                                            <td>
                                                <a onClick={() => this.showReport(cashregister.apNumber)} className='table-green-btn'>{i18.COMMON._view}</a> &nbsp;&nbsp;
                                                <a onClick={() => this.deleteReport(cashregister.apNumber)} className='table-green-btn'>{i18.BUTTONS._delete}</a>
                                            </td>
                                        </tr>
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className='row' style={{marginBottom: '20px'}}>
                            <div className='col-2 offset-2'>
                                <label htmlFor="legal_title" className="margin-top-10 margin-bottom-2 control-label" style={{marginTop: '4px', textAlign: 'right'}}>AP szám</label>
                            </div>
                            <div className='col-3' style={{textAlign: 'left'}}>
                                <Field
                                    type='text'
                                    id='apNumber'
                                    name='apNumber'
                                    label=''
                                    classLabel='control-label'
                                    classInput='bordered-input'
                                    setValue={this.setValue.bind(this)}
                                    state={this.state}
                                    style={{width: '100%'}}
                                />
                            </div>
                            <div className='col-3' style={{textAlign: 'left'}}>
                                <a
                                    onClick={() => this.addItem()}
                                    className='next-step'
                                >
                                    Hozzáadás
                                </a>
                            </div>
                        </div>
                    </div>


                </div>

                <Modal
                    isOpen={this.state.modalIsOpen}
                    onRequestClose={() => this.closeModal()}
                    style={customStyles}
                    contentLabel='Szabály szerkesztése'>
                    <div className='modal-body' style={modalBodyStyles}>
                        {this.state.reports
                            ? <div>
                                <h4>{i18.CASHREGISTER._navCashregisterReportTitle} - {this.state.reports.apNumber}</h4>
                                <table className='table table-striped  table-aibook-no-border'>
                                    <thead>
                                    <tr>
                                        <th style={{width: '150px'}}>Fájl sorszám</th>
                                        <th style={{width: '150px'}}>Zárás dátuma</th>
                                        <th style={{width: '150px'}}>Betöltve</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.reports.caches.map((cache) => {
                                        return <tr key={cache.fileNumber}>
                                            <td>{cache.fileNumber}</td>
                                            <td>{cache.closeDates}</td>
                                            <td>{cache.createdAt}</td>
                                        </tr>
                                    })}
                                    </tbody>
                                </table>
                            </div>
                            : <div className='container text-center'><Loading/></div>
                        }
                    </div>
                    <div className='modal-footer text-center'>
                        <a onClick={() => this.closeModal()} className='btn btn-danger btn-sm'>{i18.COMMON._close}</a>
                    </div>
                </Modal>

            </section>
        )
    }
}

export default NavCashregisterList


// WEBPACK FOOTER //
// ./src/components/cashregister/NavCashregisterList.js